import axios from 'axios'
import apiConfig from '../../config/apiConfig'
import { buildURL } from '../helper'
import { getBpIdParam } from '../../common/helper'
import { trackFeatureAction } from '../../common/otel'

const createFeedbackSurvey = async (requestObject: any) => {
  const bpIdParam = getBpIdParam()
  trackFeatureAction('feedback_survey_create', 'attempt')
  try {
    const { data } = await axios.post(
      `${buildURL('feedbackSurveyResponse', apiConfig.feedback)}${bpIdParam}`,
      requestObject,
    )
    trackFeatureAction('feedback_survey_create', 'success')
    return data
  } catch (error) {
    trackFeatureAction('feedback_survey_create', 'error')
    throw error
  }
}

export default createFeedbackSurvey
